// Stores-specific table state mappings
import { getSingleValue, getArrayValue } from '@/lib/utils/table-state-utils';

// Filter mappings for stores
export const storesFilterMapping = {
    name: (value: any) => ({
        'stores.name': { condition: 'contains' as const, value: getSingleValue(value) }
    }),
    type: (value: any) => ({
        'stores.type': getArrayValue(value)
    }),
    baseCurrency: (value: any) => ({
        'stores.presentmentCurrencies': getArrayValue(value)
    }),
};

export const storesQueryParamsMapping = {
    name: (value: URLSearchParams) => {
        return value.get('name')
    },
    type: (value: URLSearchParams) => {
        return value.get('type')?.split(',')
    },
    baseCurrency: (value: URLSearchParams) => {
        return value.get('baseCurrency')?.split(',')
    },
}

// Sort field mappings for stores (frontend column ID -> backend sort field)
export const storesSortMapping = {
    name: 'stores.name' as const,
    createdAt: 'stores.createdAt' as const,
    type: 'stores.type' as const,
    productsCount: 'productsCount' as const,
};
